import useParamSetting from "./useParamSetting";
import {useEffect, useRef, useState} from "react";


// labels
import ALLOTMENT_TYPES from "../util/types";

// services
import {notificationsService} from "../jwt/_services/comunication/notificationsService";

const estructure = [{
    title:"",
    body:"",
    langId:"",
    lang:"Español",
    order: 0
},{
    title:"",
    body:"",
    langId:"",
    lang:"Ingles",
    order: 1
}]


const useAllotmentNotificationLabels = (activity, allotment) => {
    const {
        loading:loadingParamSetting,
        message,
        paramSetting
    } = useParamSetting("allotment_notification_code")

    const {ps_value_max} = paramSetting || {}

    const [notification, setNotification] = useState(null)
    const [loading, setLoading] = useState(true)
    const [labels, setLabels] = useState([])

    const isMounted = useRef(true)
    const isLoading = loading || loadingParamSetting;


    // This effect is used to clean up the component when it unmounts
    useEffect(() => {
       return () => {
            isMounted.current = false;
       }
    }, []);


    // This effect is used to search for the notification when the param setting value changes
    useEffect(() => {
        searchNotification()
    }, [ps_value_max]);


    // This effect is used to form the response when the notification changes
    useEffect(() => {
        makeLabels()
    }, [notification]);



    /**
     * Searches for a notification based on the parameter setting value (`ps_value_max`).
     * Updates the `notification` state with the first result if found, or sets it to `null` on error.
     * Also manages the `loading` state during the search process.
     */
    const searchNotification = () => {
        if (!ps_value_max) {
            setLoading(false);
            return
        }


        setLoading(true);

        notificationsService.search(0, 10, {item: {code: ps_value_max}})
            .then(res => {
                if (!isMounted.current) return;
                
                if (res?.data.length > 0)
                    setNotification(res.data[0]);
            })
            .catch(err => {
                if (!isMounted.current) return;
                setNotification(null);
            })
            .finally(() => {
                if (!isMounted.current) return;
                setLoading(false);
            })
    }



    const makeLabels = () => {
        if(!notification || notification?.langs?.length <= 0)
            return
        
        const resp = notification?.langs.map( n => {
            const {label,allotment:allotmentIdentifier} = ALLOTMENT_TYPES.find(l => l.type === allotment && l.lang === n?.lang?.name)

            return {
                title: n?.title?.replace('{allotment}', label).replace('{activity}', activity?.name),
                body: n.body?.replace('{allotment}', label).replace('{activity}', activity?.name),
                lang: {
                    id: n?.lang?.id,
                    name: n?.lang?.name
                },
                order: n?.lang?.showOrder,
                allotment: allotmentIdentifier,
            }
            
        }).sort((a, b) => a.order - b.order);


        setLabels(resp)
    }
    
    
    return { isLoading, message, labels }
}

export default useAllotmentNotificationLabels;